
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"transparent","d":"M-695-13H39v79h-734z"}}),_c('path',{attrs:{"d":"M18.004 0H1.996A1.996 1.996 0 000 1.996v16.008A1.996 1.996 0 001.996 20h16.008A1.996 1.996 0 0020 18.004V1.996A1.996 1.996 0 0018.004 0zM6.429 16.429c0 .789-.64 1.428-1.429 1.428H3.571c-.789 0-1.428-.64-1.428-1.428V15c0-.789.64-1.429 1.428-1.429H5c.789 0 1.429.64 1.429 1.429v1.429zm0-5.715c0 .79-.64 1.429-1.429 1.429H3.571c-.789 0-1.428-.64-1.428-1.429V9.286c0-.79.64-1.429 1.428-1.429H5c.789 0 1.429.64 1.429 1.429v1.428zm0-5.714c0 .789-.64 1.429-1.429 1.429H3.571c-.789 0-1.428-.64-1.428-1.429V3.571c0-.789.64-1.428 1.428-1.428H5c.789 0 1.429.64 1.429 1.428V5zm5.714 5.714c0 .79-.64 1.429-1.429 1.429H9.286c-.79 0-1.429-.64-1.429-1.429V9.286c0-.79.64-1.429 1.429-1.429h1.428c.79 0 1.429.64 1.429 1.429v1.428zm0-5.714c0 .789-.64 1.429-1.429 1.429H9.286c-.79 0-1.429-.64-1.429-1.429V3.571c0-.789.64-1.428 1.429-1.428h1.428c.79 0 1.429.64 1.429 1.428V5zm5.714 5.714c0 .79-.64 1.429-1.428 1.429H15c-.789 0-1.429-.64-1.429-1.429V9.286c0-.79.64-1.429 1.429-1.429h1.429c.789 0 1.428.64 1.428 1.429v1.428zm0-5.714c0 .789-.64 1.429-1.428 1.429H15c-.789 0-1.429-.64-1.429-1.429V3.571c0-.789.64-1.428 1.429-1.428h1.429c.789 0 1.428.64 1.428 1.428V5z","fill":"currentColor","fill-rule":"nonzero"}})])])
          )
        }
      }
    